import classNames from 'classnames';

import HorizontalContainerWrapper from 'pages/NewHome/HorizontalContainerWrapper';

import useStyles from './styles';

function PageLinkingComponent() {
  const styles = useStyles({ titleColor: '' });
  const items = new Array(8).fill('');

  return (
    <HorizontalContainerWrapper className={styles.root}>
      <header className={styles.header}>
        <i className={classNames(styles.titleSkeleton, 'skeleton')} />
        <i className={classNames(styles.descriptionSkeleton, 'skeleton')} />
      </header>
      <div className={styles.grid}>
        {items.map((_, index) => (
          <i className={classNames(styles.itemSkeleton, 'skeleton')} key={index} />
        ))}
      </div>
    </HorizontalContainerWrapper>
  );
}

export default PageLinkingComponent;
